import React, { useCallback, useEffect, useState } from "react";
import {
  AutocompleteArrayInput,
  AutocompleteInput,
  EditProps,
  FormDataConsumer,
  ReferenceArrayInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useDataProvider,
  useNotify,
} from "react-admin";
import GoogleMapReact from "google-map-react";
import Marker from "./components/Marker";
import { getRouteService } from "utils/tools";
import {
  Typography,
  Grid,
  Chip,
  Tabs,
  Tab,
  Divider,
  Backdrop,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import DraggableComponent, {
  getLocationWithoutSchool,
} from "./components/DraggableComponent";
import { GridinRow } from "utils/style";
import TabPanel from "./components/TabPanel";
import AddStudentButton from "./components/AddStudentButton";
import moment from "moment";
import SaveRouteButton from "./components/SaveRouteButton";
import DeleteRouteButton from "./components/DeleteRouteButton";
import UpdateRouteButton from "./components/UpdateRouteButton";
import AddRouteButton from "./components/AddRouteButton";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import { useWindowDimensions } from "utils/dimensionHook";
import { useStyles } from "./style";
import { useField, useFormState } from "react-final-form";
import UpdateRoutePlanButton from "./components/UpdateRoutePlanButton";
import {
  a11yProps,
  getStudents,
  getStudentAddressesByStudentIds,
  colors,
  getFixedLocationDropOffBySchoolIds,
} from "./tools";
import SchoolLocationInDragable from "./components/SchoolLocationInDragable";
import LoadingComponent from "./components/LoadingComponent";
import LoadingProgressComponent from "./components/LoadingProgressComponent";
import ClipboardButton from "./components/ClipboardButton";
import BackButton from "./components/BackButton";
import RouteList from "./components/RouteList";
import AssignedSubcontractorInput from "./components/assignedSubcontractors/AssignedSubcontractorInput";
import DownloadRouteButton from "./components/DownloadRouteButton";
import CustomTimeRangeInput from "../../components/CustomTimeRangeInput";
import {
  cloneDeep,
  filter,
  find,
  findIndex,
  groupBy,
  isEmpty,
  isEqual,
  last,
  orderBy,
  pullAllWith,
} from "lodash";
import EditWrapper from "../../components/EditWrapper";

const RoutePlanEdit = (props: EditProps) => {
  const [openRoutePanel, setOpenRoutePanel] = useState<boolean>(false);

  const classes = useStyles({ openRoutePanel });
  const provider = useDataProvider();
  const notify = useNotify();
  const { width } = useWindowDimensions();
  const { id } = props;

  const [routes, setRoutes] = useState<any>([]);
  const [sortedRoutesByIndex, setSortedRoutesByIndex] = useState<any>([]);
  const [mapInstance, setMapInstance] = useState<any>(null);
  const [mapsLayoutInstance, setMapsLayout] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingProgress, setIsLoadingProgress] = useState<boolean>(false);
  const [progressValue, setProgressValue] = useState<number>(0);
  const [polylines, setPolylines] = useState<any>([]);

  const [busScheduleId, setBusScheduleId] = useState<number>();
  const [busSchedule, setBusSchedule] = useState<IBusSchedule>();
  const [students, setStudents] = useState<IStudent[]>([]);
  const [studentAddresses, setStudentAddresses] = useState<IStudentAddress[]>(
    [],
  );
  const [student, setStudent] = useState<IStudent>(null);
  const [studentAddress, setStudentAddress] = useState<IStudentAddress>(null);
  const [markers, setMarkers] = useState<any>([]);
  const [tempMarkers, setTempMarkers] = useState<any>([]);
  const [schools, setSchools] = useState([]);
  const [selectedMarkers, setSelectedMarkers] = useState<any>([]);
  const [isToSchool, setIsToSchool] = useState<boolean>(null);
  const [isEditRoute, setIsEditRoute] = useState<boolean>(false);
  const [keyRoute, setKeyRoute] = useState<number>();
  const [busSchedulePlan, setBusSchedulePlan] = useState<IBusSchedulePlans>();
  const [routeData, setRouteData] = useState<any>();
  const [routeGeometries, setRouteGeometries] = useState<IRouteGeometry[]>([]);

  useEffect(() => {
    provider.getOne("busSchedulePlans", { id: id }).then((result) => {
      setBusSchedulePlan(result.data as IBusSchedulePlans);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchRouteService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMarkers]);

  const fetchRouteService = async () => {
    let tempRoutes: any = [];
    let tempRouteGeometry: any = [];

    // selectedMarkers.forEach(async (marker: any, index: number) => {
    for (let index = 0; selectedMarkers.length > index; index++) {
      if (index < selectedMarkers.length - 1) {
        const start = selectedMarkers[index];
        const end = selectedMarkers[index + 1];

        setIsLoading(true);

        try {
          const { routePolyline: route, routeGeometry } =
            await getRouteService(start, end);

          // add index property for sorting the tempRoutes
          route.index = index;
          tempRoutes.push(route);
          tempRouteGeometry.push({
            order: index + 1,
            polyline: routeGeometry,
          });

          setRouteGeometries(tempRouteGeometry);
          // need to sort
          // because is async
          // and will make the routes not sequentially
          setSortedRoutesByIndex(orderBy(tempRoutes, ["index"], ["asc"]));
        } catch {
          // setToken(undefined);
          notify("Failed to load routeline", "warning");
          setIsLoading(false);
          break;
        }
      }
    }
  };

  useEffect(() => {
    let finalRoutes: any = [];

    // do check
    // make sure
    // the sortedRoutes is already complete filled with tempRoutes from func. getRouteService()
    if (sortedRoutesByIndex.length === selectedMarkers.length - 1) {
      sortedRoutesByIndex.forEach((sortedRoute: any) => {
        finalRoutes = [...finalRoutes, ...sortedRoute];
        setRoutes(finalRoutes);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedRoutesByIndex]);

  useEffect(() => {
    if (mapInstance !== null && mapsLayoutInstance !== null) {
      renderPolylines(mapInstance, mapsLayoutInstance);
      setIsLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapInstance, mapsLayoutInstance, routes]);

  const renderPolylines = (map: any, maps: any) => {
    const lineSymbol = {
      path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
    };

    // if polyline is already draw
    // do reset the polyline
    if (openRoutePanel) {
      removePolyline();
    }

    let geodesicPolyline = new maps.Polyline({
      path: routes,
      geodesic: true,
      strokeColor: "#3B4E90",
      strokeOpacity: 1.0,
      strokeWeight: 2,
      icons: [
        {
          icon: lineSymbol,
          offset: "100%",
          repeat: "50px",
        },
      ],
    });

    setPolylines([...polylines, ...[geodesicPolyline]]);

    geodesicPolyline.setMap(map);
  };

  const handleApiLoaded = useCallback(
    (map: any, maps: any) => {
      // use map and maps objects

      setMapInstance(map);
      setMapsLayout(maps);
    },
    [setMapInstance, setMapsLayout],
  );

  const removePolyline = () => {
    if (polylines.length > 0) {
      polylines.forEach((polyline: any) => {
        polyline.setMap(null);
      });
    }
  };

  const draggableCallback = (values: any) => {
    if (values.length === 0) {
      removePolyline();
      setSelectedMarkers(values);
    } else {
      if (isToSchool) {
        setSelectedMarkers([...values, ...schools]);
      }
      if (!isToSchool) {
        setSelectedMarkers([...schools, ...values]);
      }
    }
  };

  const manageStudentCallback = (
    selectedMarkersWithoutSchool: any,
    newValue: any,
  ) => {
    const findMarkerByKey = find(selectedMarkersWithoutSchool, [
      "markerKey",
      newValue.markerKey,
    ]);

    findMarkerByKey.students = newValue.students;
  };

  const changeLocationCallback = (newValue: any, oldValue: any) => {
    const indexData = findIndex(markers, ["markerKey", oldValue.markerKey]);

    markers[indexData] = newValue;

    if (indexData < 0) {
      markers.push(oldValue);
    }
  };

  const addToSelectedMarker = (postalCode: string) => {
    let tempSelectedMarker = [];
    const findData = find(markers, ["postalCode", postalCode]);
    tempSelectedMarker.push(findData);

    if (selectedMarkers.length > 0) {
      if (isToSchool) {
        // find the last array
        // the last is school data
        const lastArray = last(selectedMarkers);

        // need to remove first
        // because for ToSchool wave
        // school element will always put on the last
        pullAllWith(selectedMarkers, [lastArray], isEqual);

        setSelectedMarkers([
          ...selectedMarkers,
          ...tempSelectedMarker,
          ...schools,
        ]);
      } else {
        setSelectedMarkers([...selectedMarkers, ...tempSelectedMarker]);
      }
    } else {
      if (isToSchool) {
        setSelectedMarkers([...tempSelectedMarker, ...schools]);
      } else {
        setSelectedMarkers([...schools, ...tempSelectedMarker]);
      }
    }
  };

  const handleOpenRoutePanel = (isEditMode?: boolean, index?: number) => {
    if (isEditMode) {
      setIsEditRoute(isEditMode);
      setKeyRoute(index);
    }

    removePolyline();
    setOpenRoutePanel(true);
  };

  const handleCloseRoutePanel = () => {
    setOpenRoutePanel(false);
    setIsEditRoute(false);

    if (selectedMarkers.length > 0) {
      removePolyline();
      setSelectedMarkers([]);
      setRouteGeometries([]);
    }
  };

  const [tabValue, setTabValue] = React.useState(0);
  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  // set selected BusSchedule
  useEffect(() => {
    if (busScheduleId !== undefined && busScheduleId > 0) {
      provider.getOne("busSchedules", { id: busScheduleId }).then((result) => {
        setBusSchedule(result.data as IBusSchedule);

        provider
          .getOne("schools", { id: result.data.schoolId })
          .then((result) => {
            setSchools([result.data as ISchool]);
          });
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busScheduleId]);

  // set data for rendering markers
  useEffect(() => {
    if (busSchedule) {
      if (busSchedule.type === "to_school") {
        setIsToSchool(true);
      } else {
        setIsToSchool(false);
      }

      if (busSchedule.levels.length > 0) {
        setIsLoading(true);
        fetchAllLevelStudent();
      } else {
        setIsLoading(false);
        setMarkers([]);
        notify("Class Schedule doesn't have any levels", "warning");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedule]);

  const fetchAllLevelStudent = async () => {
    let allStudents: IStudent[] = [];
    const isCcaSchedule = busSchedule.type === "cca";
    const isRegularSchedule =
      busSchedule.type === "to_school" || busSchedule.type === "from_school";

    await Promise.all(
      busSchedule.levels.map(async (level: ILevel, index: number) => {
        const results: any = await getStudents(
          Number(level.id),
          isCcaSchedule,
          isRegularSchedule,
          provider,
        );

        if (results.length > 0) {
          allStudents = [...allStudents, ...results];
        }
      }),
    );
    setStudents(allStudents);
  };

  // set studentAddresses based of student
  useEffect(() => {
    if (student === null && students.length > 0) {
      setIsLoading(false);
      setIsLoadingProgress(true);
      const studentIds: any = students.map((student) => student.id);
      const _chunk = Math.ceil(studentIds.length / 100);
      const schoolIdFromStudent = students[0].schoolId;
      chunkFetch(studentIds, _chunk, schoolIdFromStudent);
    } else {
      setIsLoading(false);
      setIsLoadingProgress(false);
    }
  }, [students]);

  // set studentAddresses based of student
  const chunkFetch = async (
    studentIds: any,
    chunk: number,
    schoolId: number,
  ) => {
    let studentIdsSplice = [...studentIds];
    let _studentAddress = [...studentAddresses];

    for (let i = 0; i < chunk; i++) {
      let spliceStudentIds = studentIdsSplice.splice(0, 100);

      const data: any = await getStudentAddressesByStudentIds(
        spliceStudentIds,
        provider,
      );

      const dataFixedLocationDropOff: any =
        await getFixedLocationDropOffBySchoolIds(schoolId, provider);

      _studentAddress = [
        ..._studentAddress,
        ...data,
        ...dataFixedLocationDropOff,
      ];
      setProgressValue(_studentAddress.length);
    }
    setIsLoadingProgress(false);
    setIsLoading(true);
    setStudentAddresses(_studentAddress);
  };

  // set markers based of studentAddresses
  // and group by PostalCode for student have a same address
  useEffect(() => {
    let tempMarkers: any = [];

    const groupAddress = groupBy(studentAddresses, "postalCode");

    Object.keys(groupAddress).forEach((key: any) => {
      const findAddresses = filter(studentAddresses, { postalCode: key });

      const tempAddress: any = {
        students: [],
        ...findAddresses[0],
      };

      delete tempAddress.studentId;

      findAddresses.forEach((findAddress: any) => {
        const findStudent = find(students, ["id", findAddress.studentId]);
        if (findStudent) {
          tempAddress.students.push(findStudent);
        }
      });

      tempMarkers.push(tempAddress);
    });

    setTempMarkers(tempMarkers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentAddresses]);

  useEffect(() => {
    if (
      busSchedulePlan !== undefined &&
      studentAddress === null &&
      student === null
    ) {
      setBusScheduleId(busSchedulePlan.busScheduleId);

      let tmps: any = [];
      busSchedulePlan.nextRoutePlan?.routes?.forEach(
        (route: any, index: number) => {
          // While if the index more than or equal to 100, because we only have 100 hex colors
          while (index >= colors.length) {
            index -= colors.length;
          }

          let color = colors[index];
          route.routeLocations.forEach((location: any) => {
            location.color = color;
          });
          tmps = [...tmps, ...route.routeLocations];
        },
      );

      if (tempMarkers.length > 0) {
        let tempStudentMarkers: MakerType[] = tempMarkers;

        tempStudentMarkers.forEach((marker: MakerType, i: number) => {
          const existingMarkerFromDatabase = find(tmps, [
            "postalCode",
            marker.postalCode,
          ]);

          if (existingMarkerFromDatabase) {
            tempStudentMarkers[i] = existingMarkerFromDatabase;
            tempStudentMarkers[i].isHaveRouteFromDatabase = true;
          }
        });

        tmps.forEach((marker: MakerType) => {
          tempStudentMarkers.push(marker);
        });

        setMarkers(tempStudentMarkers);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlan, tempMarkers]);

  const handleExistingMarkers = (value: any) => {
    if (isToSchool) {
      setSelectedMarkers([...value, ...schools]);
    }
    if (!isToSchool) {
      setSelectedMarkers([...schools, ...value]);
    }
  };

  const handleAddStudent = (
    student: IStudent,
    studentAddress: IStudentAddress,
  ) => {
    const temp = cloneDeep(students);
    const existingStudent = find(students, ["id", student.id]);
    const existingSelectedMarker = find(selectedMarkers, [
      "postalCode",
      studentAddress.postalCode,
    ]);

    if (!existingStudent) {
      temp.push(student);
      setStudents(temp);
      setStudent(student);
      setStudentAddress(studentAddress);
    } else {
      if (existingSelectedMarker) {
        const tempSelectedMarkers = cloneDeep(selectedMarkers);
        const indexExistingSelectedMarker = findIndex(selectedMarkers, [
          "postalCode",
          existingSelectedMarker.postalCode,
        ]);

        tempSelectedMarkers[indexExistingSelectedMarker].students.push(
          existingStudent,
        );

        setSelectedMarkers(tempSelectedMarkers);
      } else {
        const findMarker = find(markers, [
          "postalCode",
          studentAddress.postalCode,
        ]);

        if (findMarker) {
          findMarker.students = [existingStudent];

          if (selectedMarkers.length > 0) {
            const existingSelectedMarkers = find(selectedMarkers, [
              "postalCode",
              findMarker.postalCode,
            ]);
            if (!existingSelectedMarkers) {
              findMarker.id = 0;
            }

            if (isToSchool) {
              // find the last array
              // the last is school data
              const lastArray = last(selectedMarkers);

              // need to remove first
              // because for ToSchool wave
              // school element will always put on the last
              pullAllWith(selectedMarkers, [lastArray], isEqual);

              findMarker.color =
                selectedMarkers[selectedMarkers.length - 1].color;
              setSelectedMarkers([
                ...selectedMarkers,
                ...[findMarker],
                ...schools,
              ]);
            } else {
              findMarker.color =
                selectedMarkers[selectedMarkers.length - 1].color;
              setSelectedMarkers([...selectedMarkers, ...[findMarker]]);
            }
          } else {
            findMarker.id = 0;
            findMarker.color = "#2f51bd";

            if (isToSchool) {
              setSelectedMarkers([...[findMarker], ...schools]);
            } else {
              setSelectedMarkers([...schools, ...[findMarker]]);
            }
          }
        } else {
          setStudent(student);
          setStudentAddress(studentAddress);
        }
      }
    }
  };

  useEffect(() => {
    if (studentAddress !== null && student !== null) {
      const findMarker = find(markers, [
        "postalCode",
        studentAddress.postalCode,
      ]);

      if (!findMarker) {
        const tempMarker = cloneDeep(markers);
        const tempAddress: any = {
          students: [],
          ...studentAddress,
        };

        delete tempAddress.studentId;

        tempAddress.id = 0;
        tempAddress.students.push(student);
        tempMarker.push(tempAddress);
        setMarkers(tempMarker);
      } else {
        findMarker.students.push(student);
        addToSelectedMarker(findMarker.postalCode);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student]);

  useEffect(() => {
    if (studentAddress !== null && student !== null) {
      const findMarker = find(markers, [
        "postalCode",
        studentAddress.postalCode,
      ]);

      if (findMarker) {
        addToSelectedMarker(findMarker.postalCode);
      }

      setStudentAddress(null);
      setStudent(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [markers]);

  const FormFormatter = () => {
    const busScheduleField = useField("busScheduleId");
    const idField = useField("id");
    const nextEffectiveDateField = useField("nextEffectiveDate");
    const nextRoutePlanField = useField("nextRoutePlan");
    const routePlanField = useField("routePlan");
    const statusField = useField("status");
    const createdAtField = useField("createdAt");
    const updatedAtField = useField("updatedAt");

    const { values } = useFormState();

    useEffect(() => {
      if (busSchedulePlan && isEmpty(values)) {
        busScheduleField.input.onChange(busSchedulePlan.busScheduleId);
        idField.input.onChange(busSchedulePlan.id);
        nextEffectiveDateField.input.onChange(
          busSchedulePlan.nextEffectiveDate ?? "",
        );

        const nextRoutePlan = busSchedulePlan.nextRoutePlan;
        nextRoutePlan?.routes.sort((a: any, b: any) =>
          a.name.localeCompare(b.name),
        );

        const routePlan = busSchedulePlan.routePlan;
        routePlan?.routes.sort((a: any, b: any) =>
          a.name.localeCompare(b.name),
        );

        nextRoutePlanField.input.onChange(nextRoutePlan);
        routePlanField.input.onChange(routePlan);
        statusField.input.onChange(busSchedulePlan.status);
        createdAtField.input.onChange(busSchedulePlan.createdAt);
        updatedAtField.input.onChange(busSchedulePlan.updatedAt);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [busSchedulePlan]);

    return <></>;
  };

  const breadcrumb = [
    { link: "/busSchedulePlans", title: "Route Plans" },
    { link: `/busSchedulePlans/${props.id}`, title: props.id },
  ];

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customNameWithId="Routeplan"
        actions={false}
        isHaveSchoolFilter
        {...props}
      >
        <Grid container>
          <Grid item xs={width <= 1440 ? 5 : 4} className={classes.panel}>
            <SimpleForm toolbar={null}>
              <FormFormatter />

              {openRoutePanel ? (
                <SanitizedGrid container spacing={2}>
                  <Grid item xs={12} style={GridinRow}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <BackButton
                          classes={classes.sidePanelBackButton}
                          handleCloseRoutePanel={handleCloseRoutePanel}
                        />

                        <Typography
                          variant="h6"
                          gutterBottom
                          className={classes.sidePanelTitle}
                        >
                          {isEditRoute ? (
                            <FormDataConsumer>
                              {({ formData, ...rest }) => {
                                const findRoute =
                                  formData.nextRoutePlan.routes[keyRoute];

                                return <>{findRoute?.name}</>;
                              }}
                            </FormDataConsumer>
                          ) : (
                            "New Route"
                          )}
                        </Typography>
                      </div>

                      {isEditRoute && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                          }}
                        >
                          <DownloadRouteButton
                            index={keyRoute}
                            isToSchool={isToSchool}
                            school={schools[0]}
                          />
                          <ClipboardButton
                            index={keyRoute}
                            isToSchool={isToSchool}
                            school={schools[0]}
                          />
                        </div>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <TextInput source="route.name" label="Name" />

                    <div style={{ width: "45%" }}>
                      {isEditRoute ? (
                        <>
                          <DeleteRouteButton
                            index={keyRoute}
                            handleCloseRoutePanel={handleCloseRoutePanel}
                            isUpdateRoutePlan
                          />
                          <UpdateRouteButton
                            routeLocationData={getLocationWithoutSchool(
                              `${isToSchool ? "to_school" : "from_school"}`,
                              selectedMarkers,
                            )}
                            index={keyRoute}
                            handleCloseRoutePanel={handleCloseRoutePanel}
                            routeGeometries={routeGeometries}
                            isUpdateRoutePlan
                          />
                        </>
                      ) : (
                        <SaveRouteButton
                          routeLocationData={getLocationWithoutSchool(
                            `${isToSchool ? "to_school" : "from_school"}`,
                            selectedMarkers,
                          )}
                          handleCloseRoutePanel={handleCloseRoutePanel}
                          routeGeometries={routeGeometries}
                          isUpdateRoutePlan
                        />
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <Tabs
                      value={tabValue}
                      onChange={handleChangeTab}
                      variant="fullWidth"
                      className={classes.sidePanelTabs}
                    >
                      <Tab label="Operations" {...a11yProps(0)} />
                      <Tab label="Students" {...a11yProps(1)} />
                    </Tabs>
                    <TabPanel value={tabValue} index={0}>
                      <SanitizedGrid container spacing={2}>
                        <Grid item xs={12}>
                          <CustomTimeRangeInput
                            fromSource="route.startTime"
                            fromLabel="Start Time"
                            toSource="route.endTime"
                            toLabel="End Time"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextInput
                            source="route.busBayNumber"
                            label="Bus Bay Number"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <ReferenceInput
                            source="route.driverId"
                            label="Driver"
                            reference="drivers"
                            filterToQuery={(searchText) => {
                              if (searchText !== "") {
                                return { search: searchText };
                              }
                              return {};
                            }}
                            allowEmpty
                          >
                            <AutocompleteInput
                              optionText={(choice: any) =>
                                `${choice?.fullName} (${choice?.contactNumber})`
                              }
                            />
                          </ReferenceInput>
                        </Grid>
                        <Grid item xs={12}>
                          <ReferenceArrayInput
                            source="route.backupDriverIds"
                            label="Backup Drivers"
                            reference="drivers"
                            filterToQuery={(searchText: any) => {
                              if (searchText !== "") {
                                return { search: searchText };
                              }
                              return {};
                            }}
                          >
                            <AutocompleteArrayInput
                              optionText={(choice: any) =>
                                `${choice?.fullName} (${choice?.contactNumber})`
                              }
                            />
                          </ReferenceArrayInput>
                        </Grid>

                        <Grid item xs={12}>
                          <ReferenceInput
                            source="route.busAssistantId"
                            label="Bus Assistant"
                            reference="busAssistants"
                            filterToQuery={(searchText) => {
                              if (searchText !== "") {
                                return { search: searchText };
                              }
                              return {};
                            }}
                            allowEmpty
                          >
                            <AutocompleteInput
                              optionText={(choice: any) =>
                                `${choice?.fullName} (${choice?.contactNumber})`
                              }
                            />
                          </ReferenceInput>
                        </Grid>
                        <Grid item xs={12}>
                          <ReferenceArrayInput
                            source="route.backupBusAssistantIds"
                            label="Backup Bus Assistants"
                            reference="busAssistants"
                            filterToQuery={(searchText: any) => {
                              if (searchText !== "") {
                                return { search: searchText };
                              }
                              return {};
                            }}
                          >
                            <AutocompleteArrayInput
                              optionText={(choice: any) =>
                                `${choice?.fullName} (${choice?.contactNumber})`
                              }
                            />
                          </ReferenceArrayInput>
                        </Grid>

                        <Grid item xs={12}>
                          <ReferenceInput
                            source="route.vehicleId"
                            label="Vehicle"
                            reference="vehicles"
                            filterToQuery={(searchText) => {
                              if (searchText !== "") {
                                return { search: searchText };
                              }
                              return {};
                            }}
                            allowEmpty
                          >
                            <AutocompleteInput
                              optionText={(record) =>
                                `${record?.plateNumber} - ${record?.seatCapacity
                                  ? `${record?.seatCapacity} seat(s)`
                                  : `No seat capacity info available`
                                }`
                              }
                              emptyText="-"
                            />
                          </ReferenceInput>
                        </Grid>
                        <Grid item xs={12}>
                          <ReferenceArrayInput
                            source="route.backupVehicleIds"
                            label="Backup Vehicles"
                            reference="vehicles"
                            filterToQuery={(searchText: any) => {
                              if (searchText !== "") {
                                return { search: searchText };
                              }
                              return {};
                            }}
                          >
                            <AutocompleteArrayInput optionText="plateNumber" />
                          </ReferenceArrayInput>
                        </Grid>

                        <AssignedSubcontractorInput />
                      </SanitizedGrid>
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                      <SanitizedGrid container spacing={2}>
                        <Grid item xs={12}>
                          <FormDataConsumer>
                            {({ formData, ...rest }) =>
                              formData.nextRoutePlan?.routes && (
                                <AddStudentButton
                                  handleAddStudent={handleAddStudent}
                                  school={schools[0]}
                                  busScheduleType={busSchedule.type}
                                  routes={formData.nextRoutePlan?.routes}
                                  selectedMarkers={selectedMarkers}
                                />
                              )
                            }
                          </FormDataConsumer>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider />
                        </Grid>

                        {!isToSchool && (
                          <Grid item xs={12}>
                            <SchoolLocationInDragable
                              schoolData={schools[0]}
                              waveType={"from_school"}
                            />
                          </Grid>
                        )}

                        <Grid item xs={12}>
                          <FormDataConsumer>
                            {({ formData, ...rest }) =>
                              formData.nextRoutePlan?.routes && (
                                <DraggableComponent
                                  selectedMarkers={selectedMarkers}
                                  schoolData={schools[0]}
                                  waveType={
                                    isToSchool ? "to_school" : "from_school"
                                  }
                                  busScheduleType={busSchedule.type}
                                  parentCallback={draggableCallback}
                                  parentChangeLocationCallback={
                                    changeLocationCallback
                                  }
                                  parentManageStudentCallback={
                                    manageStudentCallback
                                  }
                                  routesData={formData.nextRoutePlan?.routes}
                                />
                              )
                            }
                          </FormDataConsumer>
                        </Grid>

                        {isToSchool && (
                          <Grid item xs={12}>
                            <SchoolLocationInDragable
                              schoolData={schools[0]}
                              waveType={"to_school"}
                            />
                          </Grid>
                        )}
                      </SanitizedGrid>
                    </TabPanel>
                  </Grid>
                </SanitizedGrid>
              ) : (
                <SanitizedGrid container spacing={2}>
                  <Grid item xs={8} style={GridinRow}>
                    <Typography variant="h6" gutterBottom>
                      Route Plan
                    </Typography>
                    <Chip
                      label="Draft"
                      color="primary"
                      className={classes.statusPlanChip}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <UpdateRoutePlanButton
                      isSaveLoading={(value: boolean) => setIsLoading(value)}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      Last Update At :{" "}
                      {(() => {
                        if (busSchedulePlan) {
                          const createdAt = moment.utc(
                            busSchedulePlan.createdAt,
                          );
                          const updateAt = moment.utc(
                            busSchedulePlan.updatedAt,
                          );
                          const diffDate = updateAt.diff(createdAt, "seconds");

                          if (diffDate < 1) {
                            return "-";
                          } else {
                            return updateAt.format("DD / MM / YYYY, hh:mm A");
                          }
                        }
                      })()}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">Wave</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <ReferenceInput
                      source="busScheduleId"
                      reference="busSchedules"
                      label="Select Wave"
                      disabled
                    >
                      <SelectInput
                        optionText={(record) =>
                          `${record?.name} | ${record?.type}`
                        }
                      />
                    </ReferenceInput>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      Arrive by :{" "}
                      {busSchedule
                        ? moment(busSchedule.arrivalTime, "HH:mm").format(
                          "hh:mm A",
                        )
                        : ""}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      Days of the Weeks :{" "}
                      {busSchedule
                        ? `${(() => {
                          let days: string = "";

                          if (busSchedule.isMonday) {
                            days = days + " M,";
                          }
                          if (busSchedule.isTuesday) {
                            days = days + " T,";
                          }
                          if (busSchedule.isWednesday) {
                            days = days + " W,";
                          }
                          if (busSchedule.isThursday) {
                            days = days + " TH,";
                          }
                          if (busSchedule.isFriday) {
                            days = days + " F,";
                          }

                          return days.replace(/,(?=[^,]*$)/, "");
                        })()}`
                        : ""}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      Next Effective Date
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <CustomDatePickerInput
                      name="nextEffectiveDate"
                      label="Next Effective Date"
                      min={moment().add(1, "day").format("Y-MM-DD")}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">Routes</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <AddRouteButton
                      handleOpenRoutePanel={handleOpenRoutePanel}
                      isOpenNewRoutePanel
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormDataConsumer>
                      {({ formData, ...rest }) => {
                        return (
                          <>
                            {formData.nextRoutePlan?.routes && (
                              <RouteList
                                routes={formData.nextRoutePlan?.routes}
                                handleOpenRoutePanel={handleOpenRoutePanel}
                                handleExistingMarkers={handleExistingMarkers}
                                setRouteData={setRouteData}
                              />
                            )}
                          </>
                        );
                      }}
                    </FormDataConsumer>
                  </Grid>
                </SanitizedGrid>
              )}
            </SimpleForm>
          </Grid>

          <Grid item xs={width <= 1440 ? 7 : 8}>
            <div className={classes.mapWrapper}>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyDYGvy_HvsUfvJ_7_d4PmOH201jIFNn-iM",
                }}
                defaultCenter={{
                  lat: 1.35896,
                  lng: 103.852309,
                }}
                defaultZoom={12}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) =>
                  handleApiLoaded(map, maps)
                }
              >
                {markers.map((marker: any, key: number) => {
                  if (marker.students.length === 0) {
                    return <></>;
                  }

                  if (selectedMarkers.length > 0) {
                    const findSelectedMarker = find(selectedMarkers, [
                      "markerKey",
                      marker.markerKey,
                    ]);

                    if (!isEmpty(findSelectedMarker)) {
                      marker.isSelected = true;
                      marker.students = findSelectedMarker.students;
                    } else {
                      marker.isSelected = false;
                      marker.markerKey = `marker-${marker.postalCode}-${key}`;
                    }
                  } else {
                    marker.isSelected = !!marker.isHaveRouteFromDatabase;
                    marker.markerKey = `marker-${marker.postalCode}-${key}`;
                  }

                  marker.isSidePanelOpen = openRoutePanel;

                  return (
                    <Marker
                      lat={marker.lat}
                      lng={marker.lng}
                      key={marker.markerKey}
                      isSelected={marker.isSelected ? true : false}
                      isSidePanelOpen={marker.isSidePanelOpen ? true : false}
                      resource={marker}
                      sendToParent={(postalCode: string) =>
                        addToSelectedMarker(postalCode)
                      }
                      color={marker.color}
                    />
                  );
                })}

                {schools.map((school: any) => (
                  <Marker
                    lat={school.lat}
                    lng={school.lng}
                    key={`school-marker-${school.postalCode}`}
                    resource={school}
                    isSchool
                  />
                ))}
              </GoogleMapReact>
            </div>
          </Grid>
        </Grid>
      </EditWrapper>

      <Backdrop
        className={classes.backdropLoading}
        open={isLoading || isLoadingProgress}
      >
        {isLoading && <LoadingComponent />}
        {isLoadingProgress && (
          <LoadingProgressComponent
            progValue={progressValue}
            value={students.length}
          />
        )}
      </Backdrop>
    </>
  );
};

export default RoutePlanEdit;
